export const UPDATE_PASSWORD_SAVE = "UPDATE_PASSWORD_SAVE";
export const UPDATE_PASSWORD_SAVE_RESULT = "UPDATE_PASSWORD_SAVE_RESULT";